import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import IndexBase from "../../../Components/IndexApp";
import { RootState, store } from "../../../Redux/store";
import ClientIndexDeclaration from "./ClientIndexDeclaration";
// import { getChildActiveOnlyActif } from "../../../Redux/Actions/StudentActions";

export type DataDisptachType = {
	setCurrentPage: (value: number) => void
	setNextPage: (value: number) => void
	setPrevPage: (value: number) => void
	setTotalPage: (value: number) => void
	setTotalItems: (value: number) => void
	paginate: (pageNumber: number) => void
	limit: number
	isData: boolean
	currentPage: number
	global: {
		setLoading: (value: boolean) => void
		teachr: any
		nameSearch: string
	}
}

export type DataChildType = {
	setCurrentPage: (value: number) => void
	search: {
		nameSearch: string
		setNameSearch: (value: string) => void
	}
	loading: {
		loading: boolean
		setLoading: (value: boolean) => void
	}
	nextPage: number | undefined
	prevPage: number | undefined
	totalPage: number | undefined
	totalItems: number
	pagination: {
		pageLimit: (limitNumber: number) => void
		paginate: (pageNumber: number) => void
	}
}

export default function ClientCouseDeclare() {
	const currentClient = useSelector((state: RootState) => state.user?.currentUser.client);
	const [declarationInfo, setDeclarationInfo] = useState({
		nameSearch: "",
		totalItems: 0,
		limit: 10,
		currentPage: 0,
		totalPage: 0,
		nextPage: 0,
		prevPage: 0,
		loading: false,
	});

	const globalData = {
		setLoading: (val: boolean) => setDeclarationInfo(curr => ({ ...curr, loading: val })),
		teachr: currentClient,
		nameSearch: declarationInfo.nameSearch,
	};

	const dataDispatch: DataDisptachType = {
		setCurrentPage: (val: number) => setDeclarationInfo(curr => ({ ...curr, currentPage: val })),
		setNextPage: (val: number) => setDeclarationInfo(curr => ({ ...curr, nextPage: val })),
		setPrevPage: (val: number) => setDeclarationInfo(curr => ({ ...curr, prevPage: val })),
		setTotalPage: (val: number) => setDeclarationInfo(curr => ({ ...curr, totalPage: val })),
		setTotalItems: (val: number) => setDeclarationInfo(curr => ({ ...curr, totalItems: val })),
		paginate: (pageNumber: number) => setDeclarationInfo(curr => ({ ...curr, loading: true, currentPage: pageNumber })),
		limit: declarationInfo.limit,
		isData: true,
		currentPage: declarationInfo.currentPage,
		global: globalData,
	};

	const dataChild: DataChildType = {
		setCurrentPage: (val: number) => setDeclarationInfo(curr => ({ ...curr, currentPage: val })),
		search: {
			nameSearch: declarationInfo.nameSearch,
			setNameSearch: (value: string) => setDeclarationInfo(curr => ({ ...curr, nameSearch: value }))
		},
		loading: {
			loading: declarationInfo.loading,
			setLoading: (val: boolean) => setDeclarationInfo(curr => ({ ...curr, loading: val })),
		},
		nextPage: declarationInfo.nextPage,
		prevPage: declarationInfo.prevPage,
		totalPage: declarationInfo.totalPage,
		totalItems: declarationInfo.totalItems,
		pagination: {
			pageLimit: (limitNumber: number) => setDeclarationInfo(curr => ({ ...curr, limit: limitNumber, loading: true })),
			paginate: (pageNumber: number) => setDeclarationInfo(curr => ({ ...curr, loading: true, currentPage: pageNumber })),
		},
	};

	// useEffect(() => {
	// 	if (currentClient) {
	// 		store.dispatch(getChildActiveOnlyActif(dataDispatch));
	// 	}
	// }, []);

	return (
		<IndexBase
			index={7}
			component={
				<ClientIndexDeclaration
					client={currentClient}
					dataChild={dataChild}
					dataDispatch={dataDispatch}
				/>
			}
			teachr={currentClient}
		/>
	);
}